var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 33,
    viewBox: "0 0 29 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1653 2.88332L28.1653 30.016C28.1653 30.7588 27.8886 31.3819 27.3353 31.8852C26.7819 32.3885 26.1364 32.6393 25.3986 32.6376C25.168 32.6376 24.9254 32.6052 24.6709 32.5406C24.4164 32.4759 24.1747 32.3772 23.946 32.2443L1.39721 18.678C0.982206 18.4158 0.670486 18.0881 0.462059 17.6949C0.253632 17.3017 0.150343 16.8866 0.152187 16.4497C0.154032 16.0128 0.25732 15.5977 0.462059 15.2045C0.666798 14.8112 0.978518 14.4835 1.39721 14.2214L23.946 0.655027C24.1766 0.523952 24.4182 0.425205 24.6709 0.358795C24.9236 0.292381 25.1662 0.260052 25.3986 0.261803C26.1364 0.261803 26.7819 0.513466 27.3353 1.0168C27.8886 1.52013 28.1653 2.1423 28.1653 2.88332Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.aa39e16df07dc9ea976432d850a34bf2.svg";
export { ForwardRef as ReactComponent };